import { SearchType } from '@app/modules/search-bar/entities/search-type';
import { environment } from '@environment';

export function mapCalendarDaysLimit(searchType: SearchType)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  : { calendar_days_limit: number, calendar_users_days_limit: any[] } {
  let calendar_days_limit = 2;
  let calendar_users_days_limit = null;
  switch (searchType) {
    case SearchType.FLIGHT_RESULTS:
    case SearchType.HOME_FLIGHT:
    case SearchType.FLIGHT_USER_HISTORY:
      calendar_days_limit = environment.validate_search.flighs.calendar_days_limit;
      calendar_users_days_limit = environment.validate_search.flighs.calendar_users_days_limit;
      break;
    case SearchType.HOME_HOTELS:
    case SearchType.HOTELS_DETAIL:
    case SearchType.HOTELS_RESULTS:
      calendar_days_limit = environment.validate_search.hotels.calendar_days_limit;
      calendar_users_days_limit = environment.validate_search.hotels.calendar_users_days_limit;
      break;
    case SearchType.HOME_BUSES:
    case SearchType.BUSES_RESULTS:
      calendar_days_limit = environment.validate_search.buses.calendar_days_limit;
      calendar_users_days_limit = environment.validate_search.buses.calendar_users_days_limit;
      break;
    case SearchType.HOME_AUTOS:
    case SearchType.AUTOS_DETAIL:
    case SearchType.AUTOS_RESULTS:
      calendar_days_limit = environment.validate_search.autos.calendar_days_limit;
      calendar_users_days_limit = environment.validate_search.autos.calendar_users_days_limit;
  }
  return { calendar_days_limit, calendar_users_days_limit };
}

export function allowSameDaySelection(searchType: SearchType): boolean {
  if (
    searchType === SearchType.HOME_HOTELS ||
    searchType === SearchType.HOTELS_DETAIL ||
    searchType === SearchType.HOTELS_RESULTS ||
    searchType === SearchType.PACKAGES_HOME ||
    searchType === SearchType.PACKAGES_RESULT ||
    searchType === SearchType.HOME_AUTOS ||
    searchType === SearchType.AUTOS_DETAIL ||
    searchType === SearchType.AUTOS_RESULTS
  ) {
    return false;
  }
  return true;
}

export function daysOrNightsNumberLabel(searchType: SearchType, days: number, nights: number): number {
  if (
    searchType === SearchType.HOME_HOTELS ||
    searchType === SearchType.HOTELS_DETAIL ||
    searchType === SearchType.HOTELS_RESULTS ||
    searchType === SearchType.PACKAGES_HOME ||
    searchType === SearchType.PACKAGES_RESULT
  ) {
    return nights;
  }
  return days;
}
